import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import plusicon from "../../assets/images/bluePlus.svg";
import minusicon from "../../assets/images/Minus-svg.svg";

function FaqBox({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  // Close the FAQ box whenever the page changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <li
      className="faq-box p-4 mb-4 flex flex-col justify-center items-start self-stretch px-6 py-5 bg-[#F6F8F9] rounded-[10px] max767:mb-0"
      style={{ borderColor: "" }}
    >
      <h4
        className="faq-question flex  justify-between items-center cursor-pointer w-full text-left max767:items-start rtl:text-right"
        onClick={toggleAnswer}
        data-testid="faq-question"
      >
        <span className="text-[#002E6D] text-lg not-italic font-bold">{question}</span>
        <span className="text-xl" style={{ color: "#002E6D" }}>
          {isOpen ? (
            <span className="minus">
              <img src={minusicon} alt="Plus Icon" className="icon" />
            </span>
          ) : (
            <span className="plus">
              <img src={plusicon} alt="Minus Icon" className="icon" />
            </span>
          )}
        </span>
      </h4>
      {isOpen && (
        <div className="faq-answer mt-2 block text-[#002E6D] text-lg not-italic font-normal leading-[150%] text-left rtl:text-right"  data-testid="faq-answer">
          {answer}
        </div>
      )}
    </li>
  );
}

export default FaqBox;
